import axios from "axios";
import { apiUrl } from "../constants/common";

const instance = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});

instance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
);

export default instance;
